import { render, staticRenderFns } from "./Overview2.vue?vue&type=template&id=fee7e2a4&scoped=true&"
import script from "./Overview2.vue?vue&type=script&lang=ts&"
export * from "./Overview2.vue?vue&type=script&lang=ts&"
import style0 from "./Overview2.vue?vue&type=style&index=0&id=fee7e2a4&scoped=true&lang=scss&"
import style1 from "./Overview2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee7e2a4",
  null
  
)

export default component.exports